export const userEn = {
  "Nom d'utilisateur Deja existe": "Username Already exists",
  "Nom d'utilisateur est obligatoire": "Username is required",
  "Mot de passe est obligatoire": "Password is required",
  "Numero de telephone est obligatoire": "Phone number is required",
  "Donner au moins un role": "Give at least one role",
  
}